import { getDefaultStore, useAtomValue } from 'jotai'
import { useEffect } from 'react'
import { useLocation } from 'src/utils/router/route'
import { runOnboardingDialogs } from '..'
import { onboardingPendingAtom } from '../states'

// Opens the onboarding dialogs once the treatment redirect has landed on the
// generator route. Mounted globally; only fires when both the pending flag is
// set and we're actually on /generator/* so the dialog isn't orphaned by the
// in-flight route transition. useLocation (not useMatch) because the locale
// wrapper strips the /en prefix here — useMatch('/generator/*') matches the
// raw, prefixed pathname and never hits.
export function OnboardingPendingWatcher() {
  // Subscribe so the effect re-runs when the flag flips true.
  const pending = useAtomValue(onboardingPendingAtom)
  const { pathname } = useLocation()
  const onGenerator = pathname.startsWith('/generator/')
  useEffect(() => {
    if (!pending || !onGenerator) return
    // Read+clear against the live store (not the render closure) so a
    // StrictMode double-invoke or Suspense remount can't open twice — the
    // second pass sees the flag already cleared.
    const store = getDefaultStore()
    if (!store.get(onboardingPendingAtom)) return
    store.set(onboardingPendingAtom, false)
    runOnboardingDialogs()
  }, [pending, onGenerator])
  return null
}
